












import React, { useEffect, useState, useMemo } from "react";
import { useLoader } from '../../../../context/LoaderProvider.jsx';

const Foodenquery = () => {
    const [data, setData] = useState([]);
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const { showLoader, hideLoader } = useLoader();

    // Filter states
    const [searchType, setSearchType] = useState("vendorId");
    const [searchQuery, setSearchQuery] = useState("");
    const [statusFilter, setStatusFilter] = useState("");
    const [cityFilter, setCityFilter] = useState("");
    const [filteredData, setFilteredData] = useState([]);

    useEffect(() => {
        const handleResize = () => setScreenWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        const controller = new AbortController();
        const token = localStorage.getItem("authToken");

        const fetchUsers = async () => {
            showLoader();

            // 🔥 FORCE render cycle
            await new Promise(resolve => setTimeout(resolve, 50));

            try {
                const res = await fetch(
                    "https://backend.maamaas.com/subscription/api/admin/enquiries/getall",
                    {
                        signal: controller.signal,
                        headers: {
                            "Authorization": `Bearer ${token}`,
                            "Content-Type": "application/json"
                        }
                    }
                );

                if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);

                const fetchedData = await res.json();

                // MODIFIED FILTER: Include vendors with empty businessVerticals OR FOOD_AND_BEVERAGES
                const filteredData = fetchedData.filter(item => {
                    // If businessVerticals is empty/undefined/null, include it (assuming it's still a food vendor)
                    // Or if it includes FOOD_AND_BEVERAGES, include it
                    return !item.businessVerticals ||
                        item.businessVerticals.length === 0 ||
                        item.businessVerticals.includes("FOOD_AND_BEVERAGES");
                });

                const dataWithExtras = filteredData.map((item, index) => ({
                    ...item,
                    sno: index + 1,
                    category: item.category || "N/A",
                    subscription: item.subscription || "N/A",
                    isInterestedInSales: null,
                }));

                setData(dataWithExtras);
                setFilteredData(dataWithExtras);

            } catch (err) {
                if (err.name !== "AbortError") {
                    console.error("Error fetching users:", err);
                }
            } finally {
                hideLoader();
            }
        };


        fetchUsers();
        return () => controller.abort();
    }, []);

    // Apply filters
    useEffect(() => {
        let result = data;

        // Apply status filter
        if (statusFilter) {
            result = result.filter(item => item.status === statusFilter);
        }

        // Apply city filter
        if (cityFilter) {
            result = result.filter(item => item.city === cityFilter);
        }

        // Apply search query
        if (searchQuery.trim()) {
            const query = searchQuery.toLowerCase().trim();
            result = result.filter(item => {
                // Get the field value based on searchType
                let fieldValue;

                // Handle different field names in the data
                if (searchType === "vendorId") {
                    fieldValue = item.vendorId || item.id;
                } else if (searchType === "phoneNumber") {
                    fieldValue = item.mobileNumber || item.phone;
                } else if (searchType === "email") {
                    fieldValue = item.email;
                } else if (searchType === "name") {
                    fieldValue = item.name;
                } else if (searchType === "city") {
                    fieldValue = item.city;
                } else {
                    fieldValue = item[searchType];
                }

                if (!fieldValue) return false;

                // For phone number search, clean non-digits
                if (searchType === "phoneNumber") {
                    const cleanPartnerMobile = fieldValue.toString().replace(/\D/g, '');
                    const cleanQuery = query.replace(/\D/g, '');
                    return fieldValue.toString().toLowerCase().includes(query) ||
                        cleanPartnerMobile.includes(cleanQuery);
                }

                // For other fields
                return fieldValue.toString().toLowerCase().includes(query);
            });
        }

        setFilteredData(result);
    }, [data, statusFilter, cityFilter, searchType, searchQuery]);

    // Get unique values for filter dropdowns
    const uniqueCities = useMemo(() => {
        const cities = data.map(item => item.city).filter(Boolean);
        return [...new Set(cities)].sort();
    }, [data]);

    const uniqueStatuses = useMemo(() => {
        const statuses = data.map(item => item.status).filter(Boolean);
        return [...new Set(statuses)].sort();
    }, [data]);

    // Clear all filters
    const clearAllFilters = () => {
        setSearchQuery("");
        setStatusFilter("");
        setCityFilter("");
        setSearchType("vendorId");
    };

    // Get placeholder text based on search type
    const getPlaceholderText = () => {
        switch (searchType) {
            case "vendorId": return "Search Vendor ID";
            case "name": return "Search Name";
            case "email": return "Search Email";
            case "phoneNumber": return "Search Mobile Number";
            case "city": return "Search City";
            default: return "Search...";
        }
    };

    // Search options
    const searchOptions = [
        { value: "vendorId", label: "Vendor ID" },
        { value: "name", label: "Name" },
        { value: "email", label: "Email" },
        { value: "phoneNumber", label: "Mobile Number" },
        { value: "city", label: "City" }
    ];

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-lg-12" style={{ marginTop: "0px" }}>
                    <div
                        className="user-management-page"
                        style={{
                            overflowY: "auto",
                            height: "66vh",
                            scrollbarWidth: "thin",
                            marginTop: "15px",
                            position: "relative"
                        }}
                    >
                        <div className="user-management-container" style={{ marginLeft: "0px" }}>

                            {/* Filter Controls - Same as Logisticsclients */}
                            <div className="row g-2 mb-1 align-items-center me-0">
                                {/* Search Type Dropdown and Search Input - Side by Side */}
                                <div className="col-md-auto col-12">
                                    <div className="d-flex align-items-center" style={{ gap: '10px' }}>
                                        {/* Search Type Dropdown */}
                                        <div style={{ minWidth: '150px' }}>
                                            <select
                                                className="form-select"
                                                value={searchType}
                                                onChange={(e) => setSearchType(e.target.value)}
                                                style={{ height: "40px" }}
                                            >
                                                {searchOptions.map(option => (
                                                    <option key={option.value} value={option.value}>
                                                        {option.label}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                        {/* Search Input */}
                                        <div style={{ minWidth: '200px' }}>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder={getPlaceholderText()}
                                                value={searchQuery}
                                                onChange={(e) => setSearchQuery(e.target.value)}
                                                style={{ height: "40px" }}
                                            />
                                        </div>
                                    </div>
                                </div>

                                {/* Clear Filters Button */}
                                <div className="col-md-auto col-12">
                                    <button
                                        className="btn"
                                        onClick={clearAllFilters}
                                        style={{
                                            backgroundColor: '#6c757d',
                                            color: '#fff',
                                            height: "40px",
                                            padding: "0 15px"
                                        }}
                                    >
                                        Clear Filters
                                    </button>
                                </div>

                                {/* Refresh Data Button */}
                                <div className="col-md col-12">
                                    <div className="d-flex justify-content-start justify-content-md-end">
                                        <button
                                            className="btn"
                                            onClick={() => window.location.reload()}
                                            style={{
                                                backgroundColor: 'rgb(230 109 51)',
                                                color: '#fff',
                                                height: "40px",
                                                padding: "0 20px"
                                            }}
                                        >
                                            Refresh Data
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div className="user-table-wrapper" style={{ position: "relative", marginTop: "10px" }}>
                                <table style={{ width: "100%", fontSize: "0.95rem", borderCollapse: "collapse" }}>
                                    <thead style={{
                                        position: "sticky",
                                        top: 0,
                                        zIndex: 10,
                                        backgroundColor: "rgb(230 109 51)"
                                    }}>
                                        <tr>
                                            <th style={tableHeaderStyle}>S.NO</th>
                                            <th style={tableHeaderStyle}>Name</th>
                                            <th style={tableHeaderStyle}>Email</th>
                                            <th style={tableHeaderStyle}>Phone</th>
                                            <th style={tableHeaderStyle}>City</th>
                                            {/* <th style={tableHeaderStyle}>Vendor ID</th> */}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredData.length > 0 ? (
                                            filteredData.map((user, index) => (
                                                <tr key={user.vendorId || index} style={{ backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#fff" }}>
                                                    <td style={tableCellStyle}>{user.sno}</td>
                                                    <td style={tableCellStyle}>{user.name}</td>
                                                    <td style={tableCellStyle}>{user.email}</td>
                                                    <td style={tableCellStyle}>{user.mobileNumber}</td>
                                                    <td style={tableCellStyle}>{user.city}</td>
                                                    {/* <td style={tableCellStyle}>{user.vendorId}</td> */}
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="5" style={noDataStyle}>
                                                    {data.length === 0
                                                        ? "Loading data or no customers found."
                                                        : (searchQuery.trim() || statusFilter || cityFilter)
                                                            ? "No data found with the specified filters."
                                                            : "No data available."}
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

// Styles
const tableHeaderStyle = {
    border: "1px solid #ddd",
    textAlign: "center",
    fontWeight: "bold",
    backgroundColor: "rgb(230 109 51)",
    color: "white",
    padding: "6px",
    position: "sticky",
    top: 0,
    zIndex: 10
};

const tableCellStyle = {
    border: "1px solid #ddd",
    textAlign: "center",
    padding: "6px",
};

const noDataStyle = {
    fontStyle: "italic",
    textAlign: "center",
    padding: "10px",
    color: "#888",
};

export default Foodenquery;